import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'img',
    loadChildren: () =>
      import('./image-classfier-upload/image-classfier-upload.module').then((m) => m.ImageClassfierUploadModule),
  },
  {
    path: 'vid',
    loadChildren: () =>
      import('./image-classfier-webcam/image-classfier-webcam.module').then((m) => m.ImageClassfierWebcamModule),
  },
  {
    path: 'mnist',
    loadChildren: () =>
      import('./mnist/mnist.module').then((m) => m.MnistModule),
  },
  {
    path: 'face',
    loadChildren: () =>
      import('./face-detection/face-detection.module').then((m) => m.FaceDetectionModule),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
